import React from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { Table } from 'components/table/table';
import { TableCellDate } from 'components/table-cell/date';
import { TableCellText } from 'components/table-cell/text-cell';
import { TableColumn } from 'components/table/table-types';
import { useTableHook } from 'components/table/table-hook';
import { fetchTableItems } from '../lent-api';
import { PrivateArchivalAidCopy } from 'types';
import { SortOrder } from 'enums';
import { Button } from '@material-ui/core';

const fetchFunction = fetchTableItems<PrivateArchivalAidCopy>(
  '/api/archival-aid/private/my-copies'
);

export const columns: TableColumn[] = [
  {
    id: 'archivalAidMetadata.name',
    label: 'Archivní pomůcka',
    CellComponent: TableCellText,
  },

  {
    id: 'archivalAidMetadata.evidenceNumber',
    label: 'Číslo pomůcky',
    CellComponent: TableCellText,
  },
  {
    id: 'archivalAidMetadata.archivalCollection.evidenceNumber',
    label: 'Číslo fondu',
    CellComponent: TableCellText,
  },

  {
    id: 'archivalAidMetadata.timeRange',
    label: 'Časový rozsah',
    CellComponent: TableCellText,
  },
  {
    id: 'aisOrder.researchSheet.ordinalNumber',
    label: 'Číslo BL',
    CellComponent: TableCellText,
  },
  {
    id: 'expiration',
    label: 'Zpřístupněno do',
    CellComponent: TableCellDate,
  },
  {
    id: 'id',
    label: 'Detail',
    CellComponent: function CopyLink({ data }) {
      console.log({ purl: process.env.PUBLIC_URL });
      return (
        <Button
          variant="contained"
          color="primary"
          size="small"
          href={`${process.env.PUBLIC_URL}/soukrome-pomucky/0/${data}`}
        >
          Otevřít
        </Button>
      );
    },
    disableSort: true,
  },
];

const useStyles = makeStyles((theme: Theme) => ({
  table: {
    margin: theme.spacing(2),
  },
  title: {
    marginTop: 10,
    marginLeft: 16,
    marginRight: 16,
  },
}));

export const LentTableDigitalArchivalAids = () => {
  const classes = useStyles();
  const tableProps = useTableHook({
    fetchFunction,
    params: {
      sort: [
        { field: 'archivalAidMetadata.evidenceNumber', order: SortOrder.ASC },
      ],
    },
  });

  return (
    <>
      <Typography component="h4" className={classes.table}>
        Přehled soukromých pomůcek
      </Typography>

      <Grid container>
        <Grid className={classes.table} item xs={12}>
          <Table {...tableProps} columns={columns} expandableRows={false} />
        </Grid>
      </Grid>
    </>
  );
};
